export const ANALYTICS_SCOPE_MARKETING = 'marketing'
export const ANALYTICS_SCOPE_CHURCH = 'church'
export const ANALYTICS_SITE_PATH = '__all__'
export const ANALYTICS_STAFF_EMAIL_DOMAIN = 'magicmakrs.com'

const MAX_PATH_LENGTH = 500
const MAX_UTM_LENGTH = 200
const MAX_SESSION_ID_LENGTH = 64
const MAX_REFERRER_LENGTH = 200

export function utcDateString(ms: number): string {
	return new Date(ms).toISOString().slice(0, 10)
}

export function utcDayStartMs(date: string): number {
	return Date.parse(`${date}T00:00:00.000Z`)
}

export function eachUtcDate(startDate: string, endDate: string): string[] {
	const dates: string[] = []
	let cursor = utcDayStartMs(startDate)
	const end = utcDayStartMs(endDate)
	if (Number.isNaN(cursor) || Number.isNaN(end) || cursor > end) {
		return dates
	}
	while (cursor <= end) {
		dates.push(utcDateString(cursor))
		cursor += 24 * 60 * 60 * 1000
	}
	return dates
}

export function normalizePath(path: string): string {
	const trimmed = path.trim()
	if (!trimmed.startsWith('/')) {
		return ''
	}
	const withoutHash = trimmed.split('#')[0] ?? trimmed
	const withoutQuery = withoutHash.split('?')[0] ?? withoutHash
	const collapsed =
		withoutQuery.length > 1 && withoutQuery.endsWith('/')
			? withoutQuery.slice(0, -1)
			: withoutQuery
	return collapsed.slice(0, MAX_PATH_LENGTH)
}

export function normalizeReferrer(
	referrer: string | undefined,
	currentOrigin?: string,
): string {
	if (!referrer?.trim()) {
		return 'direct'
	}
	try {
		const url = new URL(referrer)
		if (currentOrigin && url.origin === currentOrigin) {
			return 'direct'
		}
		return url.hostname.replace(/^www\./, '').slice(0, MAX_REFERRER_LENGTH)
	} catch {
		return referrer.trim().slice(0, MAX_REFERRER_LENGTH)
	}
}

export function normalizeUtm(value: string | undefined): string | undefined {
	const trimmed = value?.trim()
	if (!trimmed) {
		return undefined
	}
	return trimmed.slice(0, MAX_UTM_LENGTH)
}

export function isValidSessionId(sessionId: string): boolean {
	return (
		sessionId.length > 0 &&
		sessionId.length <= MAX_SESSION_ID_LENGTH &&
		/^[A-Za-z0-9_-]+$/.test(sessionId)
	)
}

export function isStaffEmail(email: string | undefined): boolean {
	if (!email) {
		return false
	}
	const domain = email.split('@')[1]?.toLowerCase()
	return domain === ANALYTICS_STAFF_EMAIL_DOMAIN
}

export function sameOptionalId(
	left: string | undefined,
	right: string | undefined,
): boolean {
	return (left ?? null) === (right ?? null)
}
